import {defaultFont} from '../initial-state';
import {getStyleAttributes, normalizeOldFontWeight, getTextStyles} from '../helper';

const renderInitialState = () => {
  return defaultFont;
};

const updateFormLabelStyles = (currentState, value, modelData) => {
  if (!modelData) {
    return currentState;
  }

  const {family, style, size, weight} = getStyleAttributes(modelData, 'cbxlabel');
  const textStyles =
    modelData.safeGet('style.cbxlabel.font.textStyles') ||
    getTextStyles(weight, style);
  const normalizedWeight = normalizeOldFontWeight(modelData, weight, 'cbxlabel');

  return {
    ...currentState,
    family,
    size,
    style,
    weight: normalizedWeight,
    textStyles,
  };
};

const fontChange = (currentState, {family, weight, style}, modelData) => {
  modelData.set('style.cbxlabel.font.family', family);
  modelData.set('style.cbxlabel.font.weight', weight);
  modelData.set('style.cbxlabel.font.style', style);

  return {
    ...currentState,
    family,
    weight,
    style
  };
};

const removeFont = (currentState) => {
  return {...currentState};
};

const styleChange = (currentState, styleName, modelData) => {
  const newValue = !currentState.textStyles[styleName];

  modelData.set(`style.cbxlabel.font.textStyles.${styleName}`, newValue);

  return {
    ...currentState,
    textStyles: {
      ...currentState.textStyles,
      [styleName]: newValue,
    }
  };
};

export default {
  renderInitialState,
  updateFormLabelStyles,
  fontChange,
  removeFont,
  styleChange,
};



// WEBPACK FOOTER //
// ./src/fonts/font-picker/form/form-checkbox/font-actions.js